module.exports = __webpack_public_path__ + "7d8579a591b61abe3deea4fa586c3c37.png";